module.exports = __webpack_public_path__ + "static/media/7H.8b3adf08.svg";